import { SnowplowTrigger } from 'Snowplow'
import clickEventName from 'utils/DOM/clickEventName'
import { registerSnowplowTriggers } from 'utils/snowplow/events/userClick/registerSnowplowTriggers'
import { getAddOnValue } from 'utils/snowplow/utils/getAddOnValue'
import { getValueFromStorage } from 'utils/snowplow/utils/getValueFromStorage'

function registerSnowplowListeners() {
  const triggers: SnowplowTrigger[] = [
    {
      element: '#see-more-details-stand-alone',
      description: 'Details Page - See more details for stand alone',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'stand-alone',
      valueParser: getValueFromStorage
    },
    {
      element: '#see-more-details-dental-addon',
      description: 'Details Page - See more details for dental addon',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'dental-addon',
      valueParser: getAddOnValue
    },
    {
      element: '#see-more-details-latitude-addon',
      description: 'Details Page - See more details for latitude addon',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'latitude-addon',
      valueParser: getAddOnValue
    },
    {
      element: '#view-brochure-stand-alone',
      description: 'Details Page - View brochure for stand alone',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'stand-alone',
      valueParser: getValueFromStorage
    },
    {
      element: '#view-brochure-dental-addon',
      description: 'Details Page - View brochure for dental addon',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'dental-addon',
      valueParser: getAddOnValue
    },
    {
      element: '#view-brochure-latitude-addon',
      description: 'Details Page - View brochure for latitude addon',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'latitude-addon',
      valueParser: getAddOnValue
    },
    {
      element: '.sticky-plan__content #eligibility-link',
      description: 'Details Page - Apply for this plan',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'header-summary',
      valueParser: getValueFromStorage
    },
    {
      element: '.plan__card #eligibility-link',
      description: 'Details Page - Apply for this plan',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'stand-alone',
      valueParser: getValueFromStorage
    },
    {
      element: '#start-application-link',
      description: 'Details Page - Apply for this plan',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'summary',
      valueParser: getValueFromStorage
    }
  ]
  registerSnowplowTriggers(triggers)
}

export default registerSnowplowListeners
